import http from "../../../request";

export default {
  socials: async (context) => {
    let response = await http.get("socials", localStorage.getItem("lang"));

    context.commit("setSocials", response);
  },
};
